import { ActivityCategory } from '../types/activities';

export const CATEGORY_IMAGES: Record<ActivityCategory, string> = {
  'hiking': 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=600&h=400&fit=crop',
  'sport': 'https://images.unsplash.com/photo-1530549387789-4c1017266635?w=600&h=400&fit=crop',
  'roadtrip': 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=600&h=400&fit=crop',
  'city-tour': 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600&h=400&fit=crop',
  'cultural': 'https://images.unsplash.com/photo-1499781350541-7783f6c6a0c8?w=600&h=400&fit=crop',
  'nightlife': 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&h=400&fit=crop',
  'food': 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&h=400&fit=crop',
  'coworking': 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600&h=400&fit=crop',
  'language-exchange': 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600&h=400&fit=crop',
  'other': 'https://images.unsplash.com/photo-1506869640319-fe1a24fd76cb?w=600&h=400&fit=crop',
};

export const CATEGORY_GRADIENTS: Record<ActivityCategory, string> = {
  'hiking': 'from-emerald-500 to-green-600',
  'sport': 'from-blue-500 to-cyan-600',
  'roadtrip': 'from-amber-500 to-orange-600',
  'city-tour': 'from-cyan-500 to-teal-600',
  'cultural': 'from-rose-500 to-pink-600',
  'nightlife': 'from-fuchsia-500 to-pink-600',
  'food': 'from-orange-500 to-red-600',
  'coworking': 'from-sky-500 to-blue-600',
  'language-exchange': 'from-teal-500 to-emerald-600',
  'other': 'from-gray-500 to-slate-600',
};

export const CATEGORY_ACCENT: Record<ActivityCategory, { bg: string; text: string; light: string; border: string }> = {
  'hiking': { bg: 'bg-emerald-500', text: 'text-emerald-600 dark:text-emerald-400', light: 'bg-emerald-50 dark:bg-emerald-900/20', border: 'border-emerald-200 dark:border-emerald-800/30' },
  'sport': { bg: 'bg-blue-500', text: 'text-blue-600 dark:text-blue-400', light: 'bg-blue-50 dark:bg-blue-900/20', border: 'border-blue-200 dark:border-blue-800/30' },
  'roadtrip': { bg: 'bg-amber-500', text: 'text-amber-600 dark:text-amber-400', light: 'bg-amber-50 dark:bg-amber-900/20', border: 'border-amber-200 dark:border-amber-800/30' },
  'city-tour': { bg: 'bg-cyan-500', text: 'text-cyan-600 dark:text-cyan-400', light: 'bg-cyan-50 dark:bg-cyan-900/20', border: 'border-cyan-200 dark:border-cyan-800/30' },
  'cultural': { bg: 'bg-rose-500', text: 'text-rose-600 dark:text-rose-400', light: 'bg-rose-50 dark:bg-rose-900/20', border: 'border-rose-200 dark:border-rose-800/30' },
  'nightlife': { bg: 'bg-fuchsia-500', text: 'text-fuchsia-600 dark:text-fuchsia-400', light: 'bg-fuchsia-50 dark:bg-fuchsia-900/20', border: 'border-fuchsia-200 dark:border-fuchsia-800/30' },
  'food': { bg: 'bg-orange-500', text: 'text-orange-600 dark:text-orange-400', light: 'bg-orange-50 dark:bg-orange-900/20', border: 'border-orange-200 dark:border-orange-800/30' },
  'coworking': { bg: 'bg-sky-500', text: 'text-sky-600 dark:text-sky-400', light: 'bg-sky-50 dark:bg-sky-900/20', border: 'border-sky-200 dark:border-sky-800/30' },
  'language-exchange': { bg: 'bg-teal-500', text: 'text-teal-600 dark:text-teal-400', light: 'bg-teal-50 dark:bg-teal-900/20', border: 'border-teal-200 dark:border-teal-800/30' },
  'other': { bg: 'bg-gray-500', text: 'text-gray-600 dark:text-gray-400', light: 'bg-gray-50 dark:bg-gray-700/50', border: 'border-gray-200 dark:border-gray-600' },
};

export const CATEGORY_ICONS_MAP: Record<ActivityCategory, string> = {
  'hiking': 'Mountain',
  'sport': 'Dumbbell',
  'roadtrip': 'Car',
  'city-tour': 'MapPin',
  'cultural': 'Landmark',
  'nightlife': 'Wine',
  'food': 'UtensilsCrossed',
  'coworking': 'Laptop',
  'language-exchange': 'Languages',
  'other': 'Sparkles',
};
